import { FunctionComponent } from 'react';
import { ArticleModel } from '../../../services/content/article/models/ArticleModel';
import { getMainMediaImageByCropRatio } from '../../../services/content/image/ImageConfiguration';
import { ImageRatios, ImageSizes } from '../../../services/content/image/models/ImageModel';

type Props = {
    article: ArticleModel;
};

export const OgMetaTags: FunctionComponent<Props> = ({ article }) => {
    const WEBSITE_URL = process.env.NEXT_PUBLIC_WEBSITE_URL;
    const WEBSITE_NAME = process.env.WEBSITE_NAME;
    const imageUrl = getMainMediaImageByCropRatio(article.mainMedia, ImageRatios.RATIO_16X9, ImageSizes.SMALL);

    return (
        <>
            <meta property='fb:app_id' content={process.env.NEXT_PUBLIC_SOCIAL_FB_APP_ID} />
            <meta property='og:type' content='article' />
            <meta property='og:url' content={`${WEBSITE_URL}/article/${article.id}`} />
            <meta property='og:title' content={article.title} />
            <meta property='og:image' content={imageUrl ? imageUrl : '/placeholder_main_image.png'} />
            <meta property='og:description' content={article.subtitle ? article.subtitle : ''} />
            <meta property='og:site_name' content={WEBSITE_NAME} />
        </>
    );
};
